import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityBadges = ({ language }) => {
  const translations = {
    fr: {
      encrypted: 'Connexion sécurisée',
      compliance: 'Conforme aux normes juridiques marocaines',
      privacy: 'Protection des données client-avocat'
    },
    ar: {
      encrypted: 'اتصال آمن',
      compliance: 'متوافق مع المعايير القانونية المغربية',
      privacy: 'حماية بيانات العميل والمحامي'
    }
  };

  const t = translations?.[language];

  const badges = [
    { icon: 'Shield', text: t?.encrypted },
    { icon: 'Award', text: t?.compliance },
    { icon: 'Lock', text: t?.privacy }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-4 mt-6 md:mt-8">
      {badges?.map((badge, index) => (
        <div
          key={index}
          className="flex items-center gap-2 md:gap-3 p-3 md:p-4 bg-muted/50 rounded-lg border border-border"
        >
          <div className="flex-shrink-0 w-8 h-8 md:w-10 md:h-10 rounded-lg bg-primary/10 flex items-center justify-center">
            <Icon name={badge?.icon} size={18} className="text-primary" />
          </div>
          <p className="text-xs md:text-sm text-muted-foreground font-medium">
            {badge?.text}
          </p>
        </div>
      ))}
    </div>
  );
};

export default SecurityBadges;